import Vue from 'vue'
import VueRouter from 'vue-router'
import {Message} from "element-ui";
import login from '../views/login'

import home from '../views/home'
import config from '../views/config'
import dmgt from '../views/dmgt'
import myset from '../views/myset'
import logout from '../views/logout'
import admin from "@/views/admin";
import other from "@/views/other";
import keylist from "@/views/keylist";
import userList from "@/views/userList";
import group from "@/views/group";
import phone from "@/views/phone";
import phone_guest from "@/views/phone_guest";
import devices from "@/views/devices";
import tongji from "@/views/tongji";


Vue.use(VueRouter)


const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta:{title:'管理登录'}
  },
  {
    path: '/',
    name: 'home',
    component: home,
    children:[
      {
        path: '/devices',
        name: 'devices',
        component: devices,
        meta:{title:'设备管理'}
      },
      {
        path: '/config',
        name: 'config',
        component: config,
        meta:{title:'脚本设置'}
      },
      {
        path: '/dmgt',
        name: 'dmgt',
        component: dmgt,
        meta:{title:'数据管理'}
      },
      {
        path: '/tongji',
        name: 'tongji',
        component: tongji,
        meta:{title:'统计管理'}
      },
      {
        path: '/group',
        name: 'group',
        component: group,
        meta:{title:'自动拉群'}
      },
      {
        path: '/myset',
        name: 'myset',
        component: myset,
        meta:{title:'我的资料'}
      },
      {
        path: '/other',
        name: 'other',
        component: other,
        meta:{title:'其他设置'}
      },
      {
        path: '/phone',
        name: 'phone',
        component: phone,
        meta:{title:'号码管理'}
      },
      {
        path: '/phone_guest',
        name: 'phone_guest',
        component: phone_guest,
      },
      {
        path: '/admin',
        name: 'admin',
        component: admin,
        meta:{title:'更新管理'}
      },
      {
        path: '/keylist',
        name: 'keylist',
        component: keylist,
        meta:{title:'卡密管理'}
      },
      {
        path: '/userList',
        name: 'userList',
        component: userList,
        meta:{title:'用户管理'}
      },
      {
        path: '/logout',
        name: 'logout',
        component: logout,
        meta:{title:'退出登录'}
      },
    ]
  },

]

const router = new VueRouter({
  routes
})


let overTime = 2 * 60 * 60 * 1000;
let arrIgnore = ['/login','/phone_guest'];

router.beforeEach((to,from,next)=>{

  if (to.meta.title){
    document.title = to.meta.title;
  }

  if (!arrIgnore.includes(to.path)){

    let token = window.sessionStorage.getItem('token');
    if (!token || token === '' || token == null || token === undefined){
      next('/login');
    }

    const loginTime = window.sessionStorage.getItem('loginTime');
    if (token && token !== 'undefined' && loginTime) {

      let date = new Date().getTime();
      if (date - loginTime > overTime) {
        window.sessionStorage.clear();
        Message({
          message: "登录已失效，请重新登录",
          type: 'error',
          duration: 5 * 1000
        })
        next('/login');
      } else {
        next();
      }

    } else {
      next('/login');
    }

  }else {
    next();
  }





})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
